<template>
  <div>
    <v-app-bar app flat style="background-color: white !important">
      <div v-if="$vuetify.breakpoint.mdAndUp">
        <div class="d-flex ml-13 align-center">
          <router-link to="/" class="home-link">
            <v-img
              alt="Logo"
              class="shrink mr-2"
              contain
              src="@/assets/flybysms.svg"
              transition="scale-transition"
              width="150"
            />
          </router-link>
        </div>
      </div>

      <!-- Content to hide on larger screens -->
      <div v-else>
        <div class="d-flex ml-5 align-center">
          <router-link to="/" class="home-link">
            <v-img
              alt="Logo"
              class="shrink mr-2"
              contain
              src="@/assets/flybysms.svg"
              transition="scale-transition"
              width="120"
            />
          </router-link>
        </div>
      </div>

      <v-spacer></v-spacer>

      <router-link to="/login">
        <v-btn class="primary" plain style="border-radius: 5px !important"
          ><v-icon left>mdi-account-outline</v-icon>Login</v-btn
        >
      </router-link>
    </v-app-bar>

    <br /><br />
    <!-- Hero -->
    <section class="container py-5 mt-10 mt-md-8 mb-md-3 mb-lg-4 mb-xl-5">
      <div class="row align-items-center align-items-lg-stretch mb-2 mb-sm-3">
        <!-- Parallax gfx -->
        <div
          class="col-xl-7 col-md-6 d-flex justify-content-center overflow-hidden order-md-2 mt-n5 mt-sm-n4 mt-md-0"
        >
          <div class="mt-5">
            <div class="parallax zindex-2">
              <div class="parallax-layer zindex-2 mb-n3" data-depth="0.1">
                <div v-if="$vuetify.breakpoint.mdAndUp">
                  <img src="@/assets/hero.svg" width="500" alt="hero-image" />
                </div>

                <!-- Content to hide on larger screens -->
                <div v-else>
                  <img src="@/assets/hero.svg" width="300" alt="hero-image" />
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Text -->
        <div class="col-xl-5 col-md-6 d-flex flex-column order-md-1">
          <div
            class="text-center text-md-start pt-4 pt-sm-5 pt-xl-0 mt-sm-0 mt-lg-auto"
          >
            <div v-if="$vuetify.breakpoint.mdAndUp">
              <h1 class="display-2 font-weight-bold mb-4">
                Empower Your Communication with Our Bulk SMS Platform
              </h1>
            </div>
            <div v-else>
              <h3 class="display-1 font-weight-bold mb-4">
                Empower Your Communication with Our Bulk SMS Platform
              </h3>
            </div>
            <p class="fs-lg mb-0 grey3--text">
              Unleash the power of communication mastery through our unrivaled
              bulk SMS system.
            </p>
            <div class="mt-10">
              <router-link to="/signup">
                <v-btn
                  class="primary"
                  plain
                  large
                  style="border-radius: 5px !important"
                  >Start trial now</v-btn
                >
              </router-link>
            </div>
          </div>
          <div
            class="d-sm-flex d-md-none d-lg-flex justify-content-center justify-content-md-start pt-3 pt-md-0 mt-10"
          >
            <div class="d-flex align-items-center w-100 pe-xxl-2 mb-2 mb-md-0">
              <div class="h2 mb-0">3k+</div>
              <div class="ps-2 ms-1 grey3--text">active daily businesses</div>
            </div>
            <div class="vr d-none d-sm-block text-border my-2 mx-4"></div>
            <div class="d-flex align-items-center w-100 ps-xxl-2">
              <div class="h2 mb-0">0.5 kes</div>
              <div class="ps-2 ms-1 grey3--text">/ SMS</div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Features -->
    <section class="position-relative py-5" id="features">
      <div
        class="container position-relative zindex-5 pb-md-4 pt-md-2 pt-lg-3 pb-lg-5"
      >
        <div
          class="row justify-content-center text-center pb-3 mb-sm-2 mb-lg-3"
        >
          <div class="col-xl-6 col-lg-7 col-md-9">
            <h2 class="mb-lg-4">Welcome to FlyBySMS Bulk SMS Platform!</h2>
            <p class="fs-lg grey3--text mb-0">
              Whether you're a business owner, marketer, or community organizer,
              our feature-rich system is designed to simplify your SMS
              communication strategies.
            </p>
          </div>
        </div>
        <div class="row row-cols-1 row-cols-sm-2 row-cols-md-3 g-0 pb-xl-3">
          <!-- Item -->
          <div class="col position-relative">
            <div class="card border-0 bg-transparent rounded-0 p-md-1 p-xl-3">
              <div class="d-table p-3 mx-auto mt-3 mt-md-4">
                <v-btn
                  fab
                  depressed
                  large
                  dark
                  color="tint1"
                  style="border-radius: 5px !important"
                >
                  <v-icon color="primary">mdi-trending-up</v-icon>
                </v-btn>
              </div>
              <div class="card-body text-center">
                <h3 class="h5 pb-1 mb-2">Trading SMS Credits</h3>
                <p class="mb-0 grey3--text">
                  Trade SMS credits effortlessly and manage your balance with
                  ease. Our intuitive system lets you buy, sell, and exchange
                  SMS credits hassle-free.
                </p>
              </div>
            </div>
            <hr
              class="position-absolute top-0 end-0 w-1 h-100 d-none d-sm-block"
            />
            <hr
              class="position-absolute top-100 start-0 w-100 d-none d-sm-block"
            />
          </div>

          <!-- Item -->
          <div class="col position-relative">
            <div class="card border-0 bg-transparent rounded-0 p-md-1 p-xl-3">
              <div class="d-table p-3 mx-auto mt-3 mt-md-4">
                <v-btn
                  fab
                  depressed
                  large
                  dark
                  color="tint1"
                  style="border-radius: 5px !important"
                >
                  <v-icon color="primary"
                    >mdi-file-document-edit-outline</v-icon
                  >
                </v-btn>
              </div>
              <div class="card-body text-center">
                <h3 class="h5 pb-1 mb-2">Dynamic Templates</h3>
                <p class="mb-0 grey3--text">
                  Craft stunning, dynamic SMS templates that resonate with your
                  audience. Personalize your messages and make an impact with
                  each send.
                </p>
              </div>
            </div>
            <hr
              class="position-absolute top-0 end-0 w-1 h-100 d-none d-md-block"
            />
            <hr
              class="position-absolute top-100 start-0 w-100 d-none d-sm-block"
            />
          </div>

          <!-- Item -->
          <div class="col position-relative">
            <div class="card border-0 bg-transparent rounded-0 p-md-1 p-xl-3">
              <div class="d-table p-3 mx-auto mt-3 mt-md-4">
                <v-btn
                  fab
                  depressed
                  large
                  dark
                  color="tint1"
                  style="border-radius: 5px !important"
                >
                  <v-icon color="primary">mdi-contacts-outline</v-icon>
                </v-btn>
              </div>
              <div class="card-body text-center">
                <h3 class="h5 pb-1 mb-2">Smart Contacts Management</h3>
                <p class="mb-0 grey3--text">
                  Organize and categorize your contacts like a pro. Efficiently
                  segment your audience into contact groups for targeted
                  messaging.
                </p>
              </div>
            </div>
            <hr
              class="position-absolute top-0 end-0 w-1 h-100 d-none d-sm-block d-md-none"
            />
            <hr
              class="position-absolute top-100 start-0 w-100 d-none d-sm-block"
            />
          </div>

          <!-- Item -->
          <div class="col position-relative">
            <div class="card border-0 bg-transparent rounded-0 p-md-1 p-xl-3">
              <div class="d-table p-3 mx-auto mt-3 mt-md-4">
                <v-btn
                  fab
                  depressed
                  large
                  dark
                  color="tint1"
                  style="border-radius: 5px !important"
                >
                  <v-icon color="primary">mdi-gift-outline</v-icon>
                </v-btn>
              </div>
              <div class="card-body text-center">
                <h3 class="h5 pb-1 mb-2">Referral Rewards</h3>
                <p class="mb-0 grey3--text">
                  Spread the word and get rewarded! Our referral system lets you
                  earn credits for each new user you bring onboard.
                </p>
              </div>
            </div>
            <hr
              class="position-absolute top-0 end-0 w-1 h-100 d-none d-md-block"
            />
            <hr
              class="position-absolute top-100 start-0 w-100 d-none d-sm-block d-md-none"
            />
          </div>

          <!-- Item -->
          <div class="col position-relative">
            <div class="card border-0 bg-transparent rounded-0 p-md-1 p-xl-3">
              <div class="d-table p-3 mx-auto mt-3 mt-md-4">
                <v-btn
                  fab
                  depressed
                  large
                  dark
                  color="tint1"
                  style="border-radius: 5px !important"
                >
                  <v-icon color="primary">mdi-chart-line</v-icon>
                </v-btn>
              </div>
              <div class="card-body text-center">
                <h3 class="h5 pb-1 mb-2">Seamless Analytics</h3>
                <p class="mb-0 grey3--text">
                  Track the performance of your SMS campaigns with real-time
                  analytics. Gain insights that help you refine your strategy
                  for better results.
                </p>
              </div>
            </div>
            <hr
              class="position-absolute top-0 end-0 w-1 h-100 d-none d-sm-block"
            />
          </div>

          <!-- Item -->
          <div class="col position-relative">
            <div class="card border-0 bg-transparent rounded-0 p-md-1 p-xl-3">
              <div class="d-table p-3 mx-auto mt-3 mt-md-4">
                <v-btn
                  fab
                  depressed
                  large
                  dark
                  color="tint1"
                  style="border-radius: 5px !important"
                >
                  <v-icon color="primary">mdi-currency-usd-off</v-icon>
                </v-btn>
              </div>
              <div class="card-body text-center">
                <h3 class="h5 pb-1 mb-2">Fast Deposits and Withdrawals</h3>
                <p class="mb-0 grey3--text">
                  Easily manage your SMS credit balance with lightning-fast
                  deposits and withdrawals. Our streamlined system ensures that
                  topping up your credits or cashing out is a breeze.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="position-absolute top-0 start-0 w-100 h-100"
        style="background-color: rgba(255, 255, 255, 0.05)"
      ></div>
    </section>

    <!-- CTA -->
    <section class="tint2 py-5">
      <div class="container text-center py-1 py-md-4 py-lg-5">
        <h2 class="mb-4">Ready to Get Started?</h2>
        <p class="lead pb-3 mb-3">
          Experience the Possibilities with 5 Test Credits!
        </p>

        <router-link to="/signup">
          <v-btn
            class="primary"
            plain
            large
            style="border-radius: 5px !important"
            >Start trial now</v-btn
          >
        </router-link>
      </div>
    </section>

    <!-- Testimonials -->
    <section class="container py-5 my-1 my-md-4 my-lg-5" id="testimonials">
      <div class="row pt-2 py-xl-3">
        <div class="col-lg-3 col-md-4">
          <h2
            class="text-center text-md-start mx-auto mx-md-0 pb-3 pb-sm-4 pb-md-0 pt-md-2"
            style="max-width: 300px"
          >
            Hear from Our Champions:
          </h2>

          <!-- Slider controls (Prev / next buttons) -->
          <div
            class="d-none d-md-flex justify-content-center justify-content-md-start pb-4 mb-2 pt-2 pt-md-4 mt-md-5"
          >
            <button
              type="button"
              id="prev-testimonial"
              class="btn btn-prev btn-icon btn-sm me-2"
            >
              <i class="bx bx-chevron-left"></i>
            </button>
            <button
              type="button"
              id="next-testimonial"
              class="btn btn-next btn-icon btn-sm ms-2"
            >
              <i class="bx bx-chevron-right"></i>
            </button>
          </div>
        </div>
        <div class="col-lg-9 col-md-8">
          <div class="swiper mx-n2">
            <div class="swiper-wrapper">
              <!-- Item -->
              <div class="swiper-slide h-auto pt-4 mt-10">
                <figure class="d-flex flex-column h-100 px-2 px-sm-0 mb-0 mx-2">
                  <div
                    class="card h-100 position-relative border-0 shadow-sm pt-4"
                  >
                    <span
                      class="btn btn-icon btn-primary shadow-primary pe-none position-absolute top-0 start-0 translate-middle-y ms-4"
                    >
                      <v-icon color="white">mdi-format-quote-open</v-icon>
                    </span>
                    <blockquote class="card-body pb-3 mb-0">
                      <p class="mb-0 grey3--text">
                        Managing contacts and sending SMS campaigns used to be a
                        headache. Not anymore! This system's intuitive interface
                        and contact management tools have streamlined our
                        communication process. It's an efficiency game-changer.
                      </p>
                    </blockquote>
                    <v-rating
                      v-model="rating"
                      color="yellow darken-3"
                      background-color="grey darken-1"
                      empty-icon="$ratingFull"
                      half-increments
                      hover
                      size="20"
                    ></v-rating>
                  </div>
                  <figcaption class="ps-4 pt-4">
                    <h6 class="fs-sm fw-semibold mb-0">Amanda H.</h6>
                    <span class="fs-xs text-muted">Marketing Maven</span>
                  </figcaption>
                </figure>
              </div>

              <!-- Item -->
              <div class="swiper-slide h-auto pt-4 mt-10">
                <figure class="d-flex flex-column h-100 px-2 px-sm-0 mb-0 mx-2">
                  <div
                    class="card h-100 position-relative border-0 shadow-sm pt-4"
                  >
                    <span
                      class="btn btn-icon btn-primary shadow-primary pe-none position-absolute top-0 start-0 translate-middle-y ms-4"
                    >
                      <v-icon color="white">mdi-format-quote-open</v-icon>
                    </span>
                    <blockquote class="card-body pb-3 mb-0">
                      <p class="mb-0 grey3--text">
                        This system has taken my business to new heights. From
                        personalized templates to insightful analytics, it's a
                        comprehensive solution that's easy to use. My clients
                        love the prompt communication too!
                      </p>
                    </blockquote>
                    <v-rating
                      v-model="rating4"
                      color="yellow darken-3"
                      background-color="grey darken-1"
                      empty-icon="$ratingFull"
                      half-increments
                      hover
                      size="20"
                    ></v-rating>
                  </div>
                  <figcaption class="ps-4 pt-4">
                    <h6 class="fs-sm fw-semibold mb-0">David P.</h6>
                    <span class="fs-xs text-muted"
                      >Entrepreneur Extraordinaire</span
                    >
                  </figcaption>
                </figure>
              </div>

              <!-- Item -->
              <div class="swiper-slide h-auto pt-4 mt-10">
                <figure class="d-flex flex-column h-100 px-2 px-sm-0 mb-0 mx-2">
                  <div
                    class="card h-100 position-relative border-0 shadow-sm pt-4"
                  >
                    <span
                      class="btn btn-icon btn-primary shadow-primary pe-none position-absolute top-0 start-0 translate-middle-y ms-4"
                    >
                      <v-icon color="white">mdi-format-quote-open</v-icon>
                    </span>
                    <blockquote class="card-body pb-3 mb-0">
                      <p class="mb-0">
                        The referral rewards are a genius feature! Not only does
                        this system help us communicate flawlessly, but it also
                        rewards us for bringing others on board. Win-win for
                        effective messaging and extra credits.
                      </p>
                    </blockquote>
                    <v-rating
                      v-model="rating"
                      color="yellow darken-3"
                      background-color="grey darken-1"
                      empty-icon="$ratingFull"
                      half-increments
                      hover
                      size="20"
                    ></v-rating>
                  </div>
                  <figcaption class="ps-4 pt-4">
                    <h6 class="fs-sm fw-semibold mb-0">Michael R.</h6>
                    <span class="fs-xs text-muted">Social Connector</span>
                  </figcaption>
                </figure>
              </div>

              <!-- Item -->
              <div class="swiper-slide h-auto pt-4 mt-10">
                <figure class="d-flex flex-column h-100 px-2 px-sm-0 mb-0 mx-2">
                  <div
                    class="card h-100 position-relative border-0 shadow-sm pt-4"
                  >
                    <span
                      class="btn btn-icon btn-primary shadow-primary pe-none position-absolute top-0 start-0 translate-middle-y ms-4"
                    >
                      <v-icon color="white">mdi-format-quote-open</v-icon>
                    </span>
                    <blockquote class="card-body pb-3 mb-0">
                      <p class="mb-0">
                        I used to struggle with reaching my audience
                        effectively. But thanks to this FlyBySMS system, I've
                        witnessed a surge in engagement and sales. It's like
                        magic for my marketing campaigns!
                      </p>
                    </blockquote>
                    <v-rating
                      v-model="rating"
                      color="yellow darken-3"
                      background-color="grey darken-1"
                      empty-icon="$ratingFull"
                      half-increments
                      hover
                      size="20"
                    ></v-rating>
                  </div>
                  <figcaption class="ps-4 pt-4">
                    <h6 class="fs-sm fw-semibold mb-0">Sarah M.</h6>
                    <span class="fs-xs text-muted">Operations Whiz</span>
                  </figcaption>
                </figure>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Info links -->
    <section
      class="container pt-5 pb-4 pb-sm-5 mb-2 mb-sm-0 mb-lg-3 mb-xl-4 mt-md-2 mt-lg-4 mt-xl-5"
    >
      <div class="row row-cols-1 row-cols-sm-3 pt-sm-3 py-2">
        <div
          class="col d-flex d-sm-block d-lg-flex align-items-start mb-3 mb-sm-0"
        >
          <div
            class="d-table bg-primary shadow-primary rounded flex-shrink-0 p-2 mb-3"
          >
            <v-icon color="white">mdi-message-text-fast</v-icon>
          </div>
          <div class="ps-4 ps-sm-0 ps-lg-4 ms-lg-2 me-xl-2 pe-xl-5">
            <h3 class="h4 mb-2 mb-md-3">24/7 Chat Help</h3>
            <p class="mb-1 mb-md-2 grey3--text">
              Chat support with our customer service specialists.
            </p>
          </div>
        </div>
        <div
          class="col d-flex d-sm-block d-lg-flex align-items-start mb-3 mb-sm-0"
        >
          <div
            class="d-table bg-primary shadow-primary rounded flex-shrink-0 p-2 mb-3"
          >
            <v-icon color="white">mdi-help-circle-outline</v-icon>
          </div>
          <div class="ps-4 ps-sm-0 ps-lg-4 ms-lg-2 pe-xl-5">
            <h3 class="h4 mb-2 mb-md-3">FAQ</h3>
            <p class="mb-1 mb-md-2 grey3--text">
              Find answers. Learn more about the features and services.
            </p>
          </div>
        </div>
        <div class="col d-flex d-sm-block d-lg-flex align-items-start">
          <div
            class="d-table bg-primary shadow-primary rounded flex-shrink-0 p-2 mb-3"
          >
            <v-icon color="white">mdi-email-fast-outline</v-icon>
          </div>
          <div class="ps-4 ps-sm-0 ps-lg-4 ms-lg-2 pe-xl-5">
            <h3 class="h4 mb-2 mb-md-3">Email</h3>
            <p class="mb-1 mb-md-2 grey3--text">
              Please feel free to drop any questions to our email
              admin@flybysms.com.
            </p>
          </div>
        </div>
      </div>
    </section>

    <v-divider></v-divider>

    <!-- Footer -->
    <footer class="footer pt-5 pb-4 pb-lg-5">
      <div class="container text-center pt-lg-3">
        <div class="navbar-brand justify-content-center text-dark mb-2 mb-lg-4">
          <img
            src="@/assets/flybysms.svg"
            class="me-2"
            width="150"
            alt="Silicon"
          />
        </div>
        <ul class="nav justify-content-center pt-3 pb-4 pb-lg-5">
          <li class="nav-item">
            <a href="#" class="nav-link">Home</a>
          </li>
          <li class="nav-item">
            <a href="#features" class="nav-link">Features</a>
          </li>
          <li class="nav-item">
            <a href="#testimonials" class="nav-link">Testimonials</a>
          </li>
          <router-link to="/signup" style="text-decoration: none">
            <li class="nav-item">
              <a href="#" class="nav-link">Sign up</a>
            </li>
          </router-link>
          <router-link to="/login" style="text-decoration: none">
            <li class="nav-item">
              <a class="nav-link">Login</a>
            </li>
          </router-link>
        </ul>
        <div class="d-flex justify-content-center pt-4 mt-lg-3">
          <a
            href="#"
            class="btn btn-icon btn-secondary btn-facebook mx-2 tint1"
          >
            <v-icon color="grey3">mdi-facebook</v-icon>
          </a>
          <a
            href="#"
            class="btn btn-icon btn-secondary btn-instagram mx-2 tint1"
          >
            <v-icon color="grey3">mdi-instagram</v-icon>
          </a>
          <a href="#" class="btn btn-icon btn-secondary btn-twitter mx-2 tint1">
            <v-icon color="grey3">mdi-twitter</v-icon>
          </a>
          <a href="#" class="btn btn-icon btn-secondary btn-youtube mx-2 tint1">
            <v-icon color="grey3">mdi-linkedin</v-icon>
          </a>
        </div>
        <p class="nav d-block fs-sm text-center pt-5 mt-lg-4 mb-0">
          © 2025 Made With ❤️ By
          <a
            href="https://nilevalleylab.com"
            target="_blank"
            rel="noopener noreferrer"
            class="text-primary text-decoration-underline"
          >
            Nile Valley Lab
          </a>
        </p>
      </div>
    </footer>
  </div>
</template>

<script>
// import "bootstrap/dist/js/bootstrap.bundle.min.js";
export default {
  // components: { AppBar },
  data() {
    return { rating: 5, rating4: 4 };
  },
};
</script>

<style scoped src="bootstrap/dist/css/bootstrap.css">
/* @import "bootstrap/dist/css/bootstrap.css"; */

.v-btn {
  /* text-transform: none; */
  border-radius: 5px !important;
}
.custom-app-bar {
  background-color: white !important;
}

a.text-primary:hover {
  color: #0056b3 !important; /* Darker shade of blue */
}
</style>
